/* eslint-disable max-len */
import Button from '@material-ui/core/Button';
import PaymentButtonMessage from 'components/Cart/PaymentButton/PaymentButtonMessage';
import PaymentError from 'components/Cart/PaymentButton/PaymenteMessage/PaymentError';
import { PaymentInProgress } from 'components/Cart/PaymentButton/PaymenteMessage/PaymentInProgress';
import { enPaymentStatus } from 'enums/enPaymentStatus';
import { getPaymentButtonMessage } from 'functions';
import * as qrcode from 'qrcode';
import React, { useCallback, useEffect, useState } from 'react';
import { useObservable } from 'react-use-observable';
import { cartService } from 'services/CartService';
import { paymentProgressService } from 'services/PaymentProgressService';
import { paymentService } from 'services/PaymentService';
import { paymentWaiter } from 'services/PaymentWaiterService';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import { useStyles } from './styles';
import { Hidden } from '@material-ui/core';
import { MobilePixPaymentPanel } from './PixPaymentPanel/MobilePixPaymentPanel/index';
import { DesktopPixPaymentPanel } from './PixPaymentPanel/DesktopPixPaymentPanel/index';
import { TimerPixExpiredPanel } from './PixPaymentPanel/TimerPixExpiredPanel/index';

const Component: React.FC = () => {
  const styles = useStyles({});

  const [paymentStatus] = useObservable(() => paymentProgressService.getPaymentProgressStatus(), []);

  const singleStep = false;

  const setIdleState = useCallback(() => {
    paymentProgressService.setPaymentProgressStatus({
      status: enPaymentStatus.IDLE,
      message: ''
    });
  }, []);

  const [messageButton] = useObservable(() => {
    return paymentService
      .getCart()
      .combineLatest(cartService.getCart(), cartService.getConfig())
      .map(([payment, cart, config]) => getPaymentButtonMessage(payment, cart, config));
  }, []);

  const [waiter] = useObservable(() => paymentWaiter.getWaiter(), []);

  const [qrcodeUrl, setQrCodeUrl] = useState('');

  useEffect(() => {
    if (!waiter || !waiter.waiting) {
      return;
    }

    const url = waiter.result.url;

    qrcode.toDataURL(url, { margin: 0, width: 170 }).then((encoded) => {
      setQrCodeUrl(encoded);
    });
  }, [waiter && waiter.waiting]);

  const showPixPanel = waiter && waiter.waiting && qrcodeUrl;

  if (showPixPanel) {
    return (
      <>
        <div className={styles.component}>
          <div className="chk-pix-panel" id="pix-panel">
            <div className="chk-payment-painel pix">
              <div className="chk-pix-data">
                {waiter.status === 'running' && (
                  <>
                    <Hidden mdUp>
                      <div className={styles.component}>
                        <MobilePixPaymentPanel />
                      </div>
                    </Hidden>
                    <Hidden smDown>
                      <div className={styles.component}>
                        <DesktopPixPaymentPanel />
                      </div>
                    </Hidden>
                  </>
                )}
                {waiter.status === 'paid' && (
                  <div id="pix-complete-panel" className="pixComplete chk-payment-painel pix chk-pix-modal-container">
                    <CheckCircleIcon className={styles.iconComplete} />
                  </div>
                )}
                {waiter.status === 'waiting' && (
                  <>
                    <TimerPixExpiredPanel />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (!paymentStatus || paymentStatus.status === enPaymentStatus.IDLE) {
    return null;
  }

  return (
    <div className={styles.component}>
      <div className="chk-payment-painel">
        <div className="chk-data">
          {paymentStatus.status === enPaymentStatus.PROGRESS && <PaymentInProgress />}
          {paymentStatus.status === enPaymentStatus.ERROR && (
            <PaymentError message={paymentStatus.message} code={paymentStatus.code} idleState={setIdleState} />
          )}
          {singleStep && paymentStatus.status === enPaymentStatus.PROGRESS && (
            <Button
              id="chk-finish-payment-button"
              fullWidth
              variant="contained"
              size="large"
              classes={{
                label: 'paymentButtonLabel'
              }}
              color="primary"
              className="paymentButton chk-stepUser__btnFinish theme-button"
              disabled={true}
              disableFocusRipple={true}
            >
              <PaymentButtonMessage status={paymentStatus.status} message={messageButton} />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export const PaymentPanel = React.memo(Component);
